import React from "react";
import curveimg from "../asset/curve-image.png";

// Icon images
import clock from "../asset/clock.png";
import laptop from "../asset/laptop.png";
import wallet from "../asset/wallet.png";
import certificate from "../asset/certificate2.png";

const WhySkillara = () => {
  return (
    <>
      {/* Global CSS */}
      <style jsx global>{`
        .skillara-card {
          position: relative;
          background: white;
          border-radius: 12px;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
        }

        /* Fold-back curl */
        .skillara-card::before {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 0;
          background: linear-gradient(
            135deg,
            transparent 48%,
            rgba(0, 0, 0, 0.1) 50%
          );
          transform-origin: bottom;
          transform: perspective(400px) rotateX(0deg);
          opacity: 0;
          transition: height 0.7s ease-out,
            opacity 0.6s ease-out,
            transform 0.9s cubic-bezier(0.2, 0.8, 0.4, 1);
          z-index: 10;
          pointer-events: none;
        }

        .skillara-card::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 50px;
          background: linear-gradient(
            to top,
            rgba(0, 0, 0, 0.2),
            transparent
          );
          opacity: 0;
          transition: opacity 0.8s ease-out;
          z-index: 5;
          pointer-events: none;
        }

        .group:hover .skillara-card::before {
          height: 50px;
          opacity: 1;
          transform: perspective(400px) rotateX(50deg);
        }

        .group:hover .skillara-card::after {
          opacity: 1;
        }
      `}</style>

      <div className="bg-white w-full py-14">
        {/* Heading */}
          <h2 className="text-4xl font-extrabold text-blue-900 dark:text-white text-center">
          Why Skillara?
        </h2>

        {/* Cards */}
        <div className="flex flex-wrap justify-center gap-10 px-4 mt-12 max-w-[1500px] mx-auto">
          {[
            { icon: laptop, text: "Courses created by industry Professionals." },
            { icon: clock, text: "Realtime project-based learning." },
            { icon: laptop, text: "Internship-style task-based modules." },
            { icon: wallet, text: "Affordable pricing for students." },
            { icon: certificate, text: "Certification that adds value to resumes." },
          ].map((item, index) => (
            <div
              key={index}
              className="skillara-card group relative overflow-hidden w-[200px] md:w-[190px] lg:w-[185px] p-5 text-center"
            >
              <div className="w-16 h-16 bg-[#0b2c6b] rounded-full flex justify-center items-center mx-auto mb-4">
                <img src={item.icon} alt="" className="w-10 h-10" />
              </div>

              <h3 className="text-lg font-semibold text-gray-900 leading-snug">
                {item.text}
              </h3>

              {/* Slightly increased curve */}
              <img
                src={curveimg}
                alt=""
                className="absolute bottom-0 left-0 w-full h-[50px] object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-800 ease-in-out pointer-events-none z-0"
              />
            </div>
          ))}
        </div>

        {/* Quote */}
        <p className="text-center text-[#0b2c6b] mt-12 text-xl italic">
          “Skillara empowers students with real-world training, expert guidance,
          and the confidence to stand out in their careers”
        </p>
      </div>
    </>
  );
};

export default WhySkillara;
